import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogoIcon } from "../components/Icons/Logo";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { AuthContext } from "../context/AuthContext";
import { useAlert } from "../context/AlertContext";

export const Welcome = () => {
  const { instance, inProgress } = useMsal();
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { setAlert } = useAlert();

  const currentUser = authContext?.currentUser;
  const needsRegistration = authContext?.needsRegistration ?? false;
  const loading = authContext?.loading ?? false;
  const isAuthenticated = authContext?.isAuthenticated ?? false;

  const handleLogin = async () => {
    try {
      await instance.loginRedirect();
    } catch (error) {
      console.error("Login failed:", error);
      setAlert(
        true,
        "error",
        "Přihlášení se nezdařilo. Zkuste to prosím znovu.",
      );
    }
  };

  useEffect(() => {
    if (needsRegistration) {
      navigate("/register");
      return;
    }
    if (!currentUser) return;

    const { userType, userData } = currentUser;

    const paths: Record<string, string> = {
      organisation:
        ((userData as any)?.step_of_registration ?? 0) >= 2
          ? "/organisation/events"
          : "/register/organisation",
      volunteer:
        ((userData as any)?.step_of_registration ?? 0) >= 3
          ? "/volunteer/events"
          : "/register/volunteer",
    };

    const path = paths[userType];

    if (path) navigate(path);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, needsRegistration]);

  const msalBusy = inProgress !== InteractionStatus.None || isAuthenticated;

  return (
    <Box sx={{ minHeight: "100vh", padding: "80px" }}>
      <Box sx={{ marginBottom: "60px" }}>
        <LogoIcon />
      </Box>
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "20px",
        }}
      >
        {loading || msalBusy ? (
          <CircularProgress />
        ) : (
          <>
            <Typography component="h1" variant="h3" gutterBottom>
              Vítejte v Bridge
            </Typography>
            <Typography
              component="h2"
              variant="h5"
              sx={{ textAlign: "center" }}
            >
              Spojujeme dobrovolníky s organizacemi, které potřebují jejich
              pomoc.
            </Typography>
            <Typography
              component="h2"
              variant="h6"
              sx={{ textAlign: "center" }}
            >
              Pro vstup do aplikace se prosím přihlaste pomocí tlačítka níže.
              Pokud ještě nemáte účet, bude vám automaticky nabídnuta
              registrace.
            </Typography>
            <Typography
              component="h2"
              variant="h6"
              gutterBottom
              sx={{ textAlign: "center" }}
            >
              Těšíme se na spolupráci!
            </Typography>

            <Button
              variant="contained"
              size="medium"
              startIcon={<LoginIcon />}
              onClick={handleLogin}
            >
              Vstoupit do aplikace
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};
